import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const EPC_RATING = 'EPC rating';

export const validate = (newEntry, type, initialStateOnEntry) => {
    let newErrors = {};

    if (!newEntry.epcRatingId) {
        newErrors = {
            ...newErrors,
            epcRatingId: { error: true, message: getReqMessage(EPC_RATING) }
        };
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry);

    return newErrors;
};
